(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["collection-card"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', (event) => {
    if (event.target instanceof Element && event.target.closest('.collection-card a[href="#"]')) {
      event.preventDefault();
    }
  });
  } catch(e) { console.error(e); }
})();

})();
